import CONST from './Constant';
import axiosPrivate from '../../../../Setup/Axios/SetupAxios';
import { handleAsyncAction } from "../../../../Setup";

export const setConfig = (payload) => ({
    type: CONST.SET_CONFIG,
    payload,
});

/*****************************************************
 * Fetch All Jobs
 ****************************************************/
export const fetchJobsSuccess = (payload) => ({
    type: CONST.FETCH_JOBS_SUCCESS,
    payload: payload
});

export const fetchJobsFailed = (payload) => ({
    type: CONST.FETCH_JOBS_FAILED,
    payload: payload
});

export const fetchJobs = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/jobs', { params: filters }),
        [fetchJobsSuccess],
        [fetchJobsFailed]
    );
};

/*****************************************************
 * Fetch Failed Jobs
 ****************************************************/
export const fetchFailedJobsSuccess = (payload) => ({
    type: CONST.FETCH_FAILED_JOBS_SUCCESS,
    payload: payload
});

export const fetchFailedJobsFailed = (payload) => ({
    type: CONST.FETCH_FAILED_JOBS_FAILED,
    payload: payload
});

export const fetchFailedJobs = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/jobs/failed', { params: filters }),
        [fetchFailedJobsSuccess],
        [fetchFailedJobsFailed]
    );
};

/*****************************************************
 * Manual Run Job
 ****************************************************/
export const manualRunSuccess = (payload) => ({
    type: CONST.MANUAL_RUN_SUCCESS,
    payload: payload
});

export const manualRunFailed = (payload) => ({
    type: CONST.MANUAL_RUN_FAILED,
    payload: payload
});

export const manualRun = ({dispatch}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('core/jobs/manual-run'),
        [manualRunSuccess],
        [manualRunFailed]
    );
};

